export const mediaAreaQueryKeys = {
  all: ['media-areas'] as const,
  one: (id: string) => [...mediaAreaQueryKeys.all, id] as const,
} as const
